import DataTable from 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';

document.addEventListener('DOMContentLoaded', function () {
  // Early exit if the table doesn't exist on this page
  const tableEl = document.querySelector('#staffDirectory');
  if (!tableEl) {
    return;
  }
  
  // grab table cells for unique values
  const departments = [...new Set(
    Array.from(document.querySelectorAll('#staffDirectory tbody tr td:nth-child(3)'))
      .map(cell => cell.textContent)
  )];
  const campuses = [...new Set(
    Array.from(document.querySelectorAll('#staffDirectory tbody tr td:nth-child(4)'))
      .map(cell => cell.textContent)
  )];
  
  // build filters
  const departmentFilter = document.createElement('div');
  departmentFilter.className = 'mb-3 me-3';
  departmentFilter.innerHTML = `
    <label for="departmentFilter" class="form-label">Department</label>
    <select id="departmentFilter" class="form-select">
      <option value="">All Departments</option>
      ${departments.map(dept => `<option value="${dept}">${dept}</option>`).join('')}
    </select>
  `;
  
  const campusFilter = document.createElement('div');
  campusFilter.className = 'mb-3 me-3';
  campusFilter.innerHTML = `
    <label for="campusFilter" class="form-label">Campus</label>
    <select id="campusFilter" class="form-select">
      <option value="">All Campuses</option>
      ${campuses.map(campus => `<option value="${campus}">${campus}</option>`).join('')}
    </select>
  `;
  
  // clear button, hidden by default
  const clearFiltersButton = document.createElement('div');
  clearFiltersButton.className = 'mb-3 d-flex align-items-end d-none';
  clearFiltersButton.innerHTML = `
    <button id="clearFilters" class="btn btn-outline-secondary">Clear Filters</button>
  `;
  
  // container & insertion
  const filterContainer = document.createElement('div');
  filterContainer.className = 'd-flex mb-3';
  filterContainer.append(departmentFilter, campusFilter, clearFiltersButton);
  tableEl.parentNode.insertBefore(filterContainer, tableEl);
  
  // initialize DataTable with custom DOM structure that includes table-responsive
  const table = new DataTable('#staffDirectory', {
    paging: true,
    lengthMenu: [10, 25, 50, 100],
    searching: true,
    info: true,
    responsive: true,
    order: [[0, 'asc']],
    language: { search: "Search by name:" },
    // Custom DOM structure - controls outside, table inside responsive wrapper (no Bootstrap grid inside responsive wrapper)
    dom: "<'d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3'<'mb-2 mb-md-0'l><'mb-2 mb-md-0'f>>" +
         "<'table-responsive'<'w-100'tr>>" +
         "<'d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-3'<'mb-2 mb-md-0'i><'mb-2 mb-md-0'p>>",
    // Custom CSS classes for styling
    initComplete: function() {
      // Add custom styling to make the search input full width on mobile
      const searchDiv = document.querySelector('.dataTables_filter');
      if (searchDiv) {
        searchDiv.classList.add('mb-2', 'mb-md-0');
        const searchInput = searchDiv.querySelector('input');
        if (searchInput) {
          searchInput.classList.add('form-control');
        }
      }
      
      // Style the length select
      const lengthDiv = document.querySelector('.dataTables_length');
      if (lengthDiv) {
        lengthDiv.classList.add('mb-2', 'mb-md-0');
        const lengthSelect = lengthDiv.querySelector('select');
        if (lengthSelect) {
          lengthSelect.classList.add('form-select', 'd-inline-block', 'w-auto');
        }
      }
    }
  });
  
  // helper to show/hide clear button
  const updateClearButton = () => {
    const show = 
      document.querySelector('#departmentFilter').value !== '' ||
      document.querySelector('#campusFilter').value !== '';
    clearFiltersButton.classList.toggle('d-none', !show);
  };
  
  // filter handlers
  document.querySelector('#departmentFilter').addEventListener('change', function() {
    table.column(2).search(this.value).draw();
    updateClearButton();
  });
  
  document.querySelector('#campusFilter').addEventListener('change', function() {
    table.column(3).search(this.value).draw();
    updateClearButton();
  });
  
  // clear filters
  document.querySelector('#clearFilters').addEventListener('click', function() {
    document.querySelector('#departmentFilter').value = '';
    document.querySelector('#campusFilter').value = '';
    table.search('').columns().search('').draw();
    updateClearButton();
  });
});
